module.exports = __webpack_public_path__ + "img/icon.d2877480.png";